import "@src/shared/utils/faker/extensions";
import "@src/shared/utils/faker/seed";

import "@el8/vital/dist/vital.css";
import "@src/shared/utils/http/initApiClient";
import "@src/shared/utils/msw/initMSW";
import "@src/shared/utils/observability/datadog";
import "@src/shared/utils/observability/sentry";

import "@src/app.css";

import { StrictMode, useMemo } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { RootV2Route } from "@src/features/auth/v2";
import { IsChromeExtensionProvider } from "@src/features/chrome";

import { ErrorBoundary } from "../../deprecated/routes/error-boundary";
import Root from "../../deprecated/routes/root";
import Status from "../../deprecated/routes/status";
import { queryClient } from "../../queryClient";
import { useStitchContainer } from "../../shared/hooks/useStitchContainer";
import { ReactQueryClientProvider } from "../../shared/providers/reactQuery";
import { UrlContextProvider } from "../../shared/providers/urlContext";
import { createV2Routes } from "../v2Routes";

function createRouter() {
  const router = createBrowserRouter([
    {
      id: "root",
      path: "/",
      element: <Root />,
      errorElement: <ErrorBoundary />,
      children: [
        {
          path: "status",
          element: <Status />,
        },
        {
          element: <RootV2Route />,
          children: createV2Routes(),
        },
      ],
    },
  ]);

  return router;
}

const root = document.getElementById("root");

/**
 * Web Application (Data Mode)
 *
 * Uses createBrowserRouter for client-side routing with data loading.
 * Authentication is handled by Better Auth (cookie session); see `auth/client.ts`.
 */
function App() {
  useStitchContainer();

  const router = useMemo(() => createRouter(), []);

  return (
    <StrictMode>
      <div id="stitch-container">
        <IsChromeExtensionProvider isChromeExtension={false}>
          <ReactQueryClientProvider queryClient={queryClient}>
            <UrlContextProvider>
              <RouterProvider router={router} />
            </UrlContextProvider>
          </ReactQueryClientProvider>
        </IsChromeExtensionProvider>
      </div>
    </StrictMode>
  );
}

if (root) {
  createRoot(root).render(<App />);
}
